import * as React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
const galleryImages = [{
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-AAOM-scaled.jpg?v=s403m5463m",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-AAOM-scaled.jpg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-AAOM-scaled.jpg",
  alt: "Neon Echoes Album Cover",
  caption: "AN AUDIENCE OF MOUNTAINS",
  credits: "Music - Lyrics - Mixing - Mastering (tracks 8-9) - Arranging - Recording - Performance: Guitars, Synth, Charango, Vocals, Tin Whistle, Percussion, Melodica, Kalimba",
  link: "https://old-water.ffm.to/anaudienceofmountains"
}, {
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Aguanta-scaled.jpg?v=2zzxk43izj5",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Aguanta-scaled.jpg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Aguanta-scaled.jpg",
  alt: "Ether Dreams Album Cover",
  caption: "Aguanta",
  credits: "Mastering - Music - Lyrics - Mixing - Recording - Performance: Guitars, Vocals, Tin Whistle, Tongue Drum",
  link: "https://old-water.ffm.to/aguantafeatselvamonte"
}, {
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Wayside-Treasures-scaled.jpg?v=zamx65ndqv",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Wayside-Treasures-scaled.jpg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Wayside-Treasures-scaled.jpg",
  alt: "Digital Dust Album Cover",
  caption: "Wayside Treasures",
  credits: "Music - Mixing - Mastering - Arranging - Recording - Performance: Guitars",
  link: "https://old-water.ffm.to/waysidetreasures"
}, {
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Mountain-Edits-scaled.jpg?v=n01e1j0bbfo",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Mountain-Edits-scaled.jpg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Mountain-Edits-scaled.jpg",
  alt: "Silent Void Album Cover",
  caption: "Mountain Edits",
  credits: "Mastering - Music - Lyrics - Mixing - Arranging - Recording - Performance: Guitars, Synth, Charango, Vocals, Tin Whistle, Percussion, Melodica, Kalimba",
  link: "https://old-water.ffm.to/mountainedits"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Front-Cover-website-temp.jpg?v=e36u1emv0yj",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Front-Cover-website-temp.jpg?v=ztwkcpmhvvl",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Front-Cover-website-temp.jpg?v=9qmp13h39q8",
  alt: "Kinetic Pulse Album Cover",
  caption: "The New Invention",
  credits: "Music - Lyrics - Arranging - Recording - Performance: Guitars, Bass, Mandolin, Vocals, Piano, Percussion",
  link: "https://emubands.ffm.to/thenewinvention"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/OW-Jam-Tracks-Volume-I-Final-Cover-Art-scaled.png?v=xxf9blgo0b",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/OW-Jam-Tracks-Volume-I-Final-Cover-Art-scaled.png?v=wpnrjxhff6n-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/OW-Jam-Tracks-Volume-I-Final-Cover-Art-scaled.png?v=h9te2fbp2bs-wvc-sizes",
  alt: "Sonic Bloom Album Cover",
  caption: "Volume I",
  credits: "Music - Arranging - Recording - Performance: Guitars, Bass, Mandolin, Vocals, Piano, Percussion",
  link: "https://open.spotify.com/album/09puHGfkLZeMwMQAwcPoav?si=6YMVmC5cT4mnMSDjRI0U5g"
}, {
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-OWJT2-scaled.jpg?v=yw874v86xk",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-OWJT2-scaled.jpg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-OWJT2-scaled.jpg",
  alt: "Velvet Frequency Album Cover",
  caption: "Volume II",
  credits: "Music - Mixing - Arranging - Recording - Performance: Guitars, Synth, Charango, Vocals, Tin Whistle, Percussion, Melodica, Kalimba",
  link: "https://owjamtracks.ffm.to/volumeii"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Album-Cover.png?v=dxscm5irf4a",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Album-Cover.png?v=w4kjloweck7",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Album-Cover.png?v=kmffbqnk7fk",
  alt: "Orbital Path Album Cover",
  caption: "Smithfield: The Soundtrack",
  credits: "Composition - Mixing - Mastering - Performance (Guitar, Charango, Shaker, Drum)",
  link: "https://oldwater.ffm.to/smithfield-thesoundtrack"
}, {
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-DS1.jpg?v=ck3kd09fj0n",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-DS1.jpg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-DS1.jpg",
  alt: "Neon Horizon Album Cover",
  caption: "Dirty Selfie",
  credits: "Mastering - Mixing - Composition - Editing - Performance: Guitars, Bass",
  link: "https://dirtyselfie.ffm.to/dirtyselfie"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/277363841_5589199297761283_1126073759712198043_n.jpg?v=tvw83lvl0p",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/277363841_5589199297761283_1126073759712198043_n.jpg?v=8xg22pbv1nh",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/277363841_5589199297761283_1126073759712198043_n.jpg?v=2txcnsg0jfx",
  alt: "The Future is behind us Album Cover",
  caption: "The Future is behind us",
  credits: "Songwriting - Performance: Guitar",
  link: "https://open.spotify.com/album/1MJuWQASjalAll5aMpn0CO?si=yFUwj3GMRDyilLckFLUXew&nd=1&dlsi=111cfc30e16341cd"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/324626946_563566725338492_4071046814754388836_n.jpg?v=w48uxp8611",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/324626946_563566725338492_4071046814754388836_n.jpg?v=xft9v4xr2pt",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/324626946_563566725338492_4071046814754388836_n.jpg?v=kgluh5aoyt",
  alt: "Up To Our Necks Album Cover",
  caption: "Up To Our Necks",
  credits: "Songwriting - Performance: Guitar",
  link: "https://open.spotify.com/album/46ssCtzJmw8Lyp6nzFJnPZ?si=voPyUVUqRQuTMazNbx0eKg&nd=1&dlsi=6b6bf8f07ddb40c2"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2024-02-05-at-19.59.52.png",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2024-02-05-at-19.59.52.png-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2024-02-05-at-19.59.52.png-wvc-sizes",
  alt: "Artefacts Album Cover",
  caption: "Artefacts",
  credits: "Songwriting - Performance: Guitar",
  link: "https://open.spotify.com/album/76iCtRZi4mRsxMQhFciRFI?si=idWzmJHhSlydVVVOYc5iaA&nd=1&dlsi=25b04ad1f6f84f57"
}, {
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-EIH-TPIDA.jpg?v=3orlj6tb72v",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-EIH-TPIDA.jpg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-EIH-TPIDA.jpg",
  alt: "The Past Is dead ahead Album Cover",
  caption: "The Past Is dead ahead",
  credits: "Songwriting - Performance: Guitar",
  link: "https://open.spotify.com/album/4m2YpfwNtaPr13IH6DRYvN?si=musl6U1gSF2oYn_cWpSPSw&nd=1&dlsi=d09a600dface42af"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/WhatsApp-Image-2025-11-30-at-16.35.32.jpeg?v=j4qhjcg8kjk",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/WhatsApp-Image-2025-11-30-at-16.35.32.jpeg?v=iuyczzr6sef",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/WhatsApp-Image-2025-11-30-at-16.35.32.jpeg?v=2vda25pon5l",
  alt: "Ones & Zeros Album Cover",
  caption: "Ones & Zeros",
  credits: "Songwriting - Performance: Guitar",
  link: "https://open.spotify.com/album/1xaQKi6HFiglEiWFQyVNLw?si=GDaEOMB_S5iEoUeqN0IF5g&nd=1&dlsi=f9982957dcb9454c"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2025-11-20-at-13.40.00.png",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2025-11-20-at-13.40.00.png",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2025-11-20-at-13.40.00.png",
  alt: "Up to our necks - Radio Edit Album Cover",
  caption: "Up to our necks - Radio Edit",
  credits: "Songwriting - Performance: Guitar",
  link: "https://open.spotify.com/album/0nZ08GwFmeXt9SdGUc7G9J?si=0CVZ7cygRcq6EknZpo5wsw&nd=1&dlsi=8d261db815f14d5e"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/invisible_colours_cover.jpg?v=ikm5ii5dz1f",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/invisible_colours_cover.jpg?v=f9oqbekjaf5",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/invisible_colours_cover.jpg?v=864l351ufo6",
  alt: "Invisible colours Album Cover",
  caption: "Invisible colours",
  credits: "Arranging - Performance: Guitar, Tenor Mandola",
  link: "https://open.spotify.com/album/6U0t6oX5J62A91dd6WkW11?si=wtee6fD-SuiAgo74lTovCw&nd=1&dlsi=500bf5bd03fe4079"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Ruth-Owens-EP-Cover.jpeg?v=6fu82d523hw",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Ruth-Owens-EP-Cover.jpeg?v=7zsnui7a2ob",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Ruth-Owens-EP-Cover.jpeg?v=nejsulkvfj",
  alt: "As You Mean to Go On Album Cover",
  caption: "As You Mean to Go On",
  credits: "Arranging - Performance: Guitar, Mandolin",
  link: "https://soundcloud.com/ruthowensmusic/sets/asyoumeantogoon"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Myoho-youtube.jpg?v=rmmakl9e7z",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Myoho-youtube.jpg?v=t3ik82lnlkh",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Myoho-youtube.jpg?v=vckstgybv3",
  alt: "Myoho Valley Youtube Album Cover",
  caption: "Myoho Valley Youtube",
  credits: "Music - Production - Recording - Video Editing",
  link: "https://youtube.com/@myohovalleyyt?si=p3UK18I7RlLUN6S4"
}, {
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Norris-Brown.jpg?v=qhtiru7xi8m",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Norris-Brown.jpg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Norris-Brown.jpg",
  alt: "Norris-Brown Album Cover",
  caption: "Norris-Brown",
  credits: "Mix & Master for ´Turn Out the Light´",
  link: "https://www.norris-brown.com/home"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Soundtrack-Cover-scaled.png?v=b6vyp1z96f",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Soundtrack-Cover-scaled.png?v=dj48qdo45th",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Soundtrack-Cover-scaled.png?v=w7s1z666le",
  alt: "Coffee & Milk: Soundtrack Album Cover",
  caption: "Coffee & Milk: Soundtrack",
  credits: "Composition - Mixing - Mastering - Recording - Performance: Guitar, Virtual Strings",
  link: "https://example.com/infinite-loop"
}, {
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/bamboo-Hwach-upcoming.jpg",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/bamboo-Hwach-upcoming.jpg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/bamboo-Hwach-upcoming.jpg",
  alt: "BAMBOO UPCOMING",
  caption: "バンブーホワチャーズ - BAMBOO HWACHAS",
  credits: "Editing - Mixing",
  link: "https://www.instagram.com/bamboo_hwachas"
}, {
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/DS2.jpg",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/DS2.jpg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/DS2.jpg",
  alt: "DS2",
  caption: "Dirty Selfie II",
  credits: "Mastering - Mixing - Composition - Editing - Performance: Guitars, Bass",
  link: "https://dirtyselfie.ffm.to/dirtyselfie"
}, {
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/OW3.jpg?v=4rlg3rrt9xf",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/THE-LIGHT-EDIT-UPCOMING.jpg?v=nd5s6iaskxj",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/THE-LIGHT-EDIT-UPCOMING.jpg?v=fral8pwmd9",
  alt: "OW3",
  caption: "Øld Water III",
  credits: "Music - Lyrics - Mixing - Mastering - Arranging - Recording - Performance: Guitars, Programming, Charango, Vocals, Tin Whistle, Percussion, Melodica, Kalimba",
  link: "#"
}, {
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/THE-LIGHT-EDIT-UPCOMING.jpg?v=w2lc8idws2",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/THE-LIGHT-EDIT-UPCOMING.jpg?v=i17hfzlw86",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/THE-LIGHT-EDIT-UPCOMING.jpg?v=xr6ewcyrfnb",
  alt: "The Light",
  caption: "The Light (Radio Edit)",
  credits: "Arranging - Editing",
  link: "https://www.youtube.com/watch?v=0xFzuAxzSnM&list=PLsai2MhJ7NGTZXZHH00Z0o7obNiSyH82T&index=11"
}];
export default function StaticAlbumGallery() {
  return <section data-section-id="256222" id="static-album-gallery" className="text-foreground py-8 md:py-12 border-t border-border dark bg-background/0">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <h2 className="font-bold font-serif uppercase tracking-tighter mb-4 !text-3xl">MUSIC COMPOSITION & PRODUCTION</h2>
        <p className="font-mono text-sm md:text-base text-muted-foreground mb-8 md:mb-12 max-w-3xl uppercase tracking-wider"><span className="!font-sans" data-ast-id="f:/src/pages/Portfolio/sections/StaticAlbumGallery.tsx|sig:yzi4fj" data-ast-start="13913" data-ast-end="14150"><span className="!font-serif" data-ast-id="f:/src/pages/Portfolio/sections/StaticAlbumGallery.tsx|sig:2tk5ed" data-ast-start="13942" data-ast-end="14143">CREDITS INCLUDE COMPOSITION, MIXING, MASTERING, PERFORMANCE WORK AND MORE. HOVER THE MOUSE OVER EACH IMAGE FOR SPECIFIC CREDITS AND CLICK TO LISTEN OR FIND OUT MORE</span></span></p>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
          {galleryImages.map((image, i) => <Link key={i} to={image.link} newTab data-index={i} className="group relative overflow-hidden rounded-md shadow-md bg-card">
              <AspectRatio ratio={1 / 1}>
                <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" className="object-cover w-full h-full transition-transform duration-700 ease-out group-hover:scale-110" />
                <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center p-4">
                  <span className="text-primary font-default text-sm md:text-base font-semibold text-center tracking-tight uppercase">
                    {image.caption}
                  </span>
                  {image.credits && <p className="text-primary/80 font-default text-xs text-center mt-1">
                      {image.credits}
                    </p>}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-secondary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none mix-blend-overlay" />
              </AspectRatio>
            </Link>)}
        </div>
      </div>
    </section>;
}